import React from "react";
import CircularProgress from '@mui/material/CircularProgress'
import Box from "@mui/material/Box";

function Spinner() {
  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99,
        background: 'rgba(0,0,0,0.4)'
      }}
    >
      <CircularProgress disableShrink />
    </Box>
  );
}

export default Spinner;
